<template>
  <b-container fluid style="margin-top: 25px">
    <b-row>
      <b-col lg="6" offset-lg="3" style="text-align: center"><span><h2>Please Select a Winery to Edit</h2></span>
      </b-col>
    </b-row>

    <div v-for="group in groupsUpdated" style="text-align: center">

      <b-row style="padding: 5px; text-align: center">
        <b-col cols="3"></b-col>
        <b-col cols="6" style="text-align: center">
          <b-container @click="setGroup(group._id, group.name, group.entityType)" fluid="md">
            <b-card align="width: 100%;center;"
                    style="color: green; background-color: #f2f2f2; padding: 5px">
              <b-row>
                <b-col cols="1" style="text-align: left">
                  <img v-if="group.entityType === `WINE` && group.county === 28"
                       :src="iconToDisplay(group.entityType,group.county)"
                       alt="NapaGreen Winery"
                       style="height: 75px; float: right; clear: right; color: lightgreen">
                  <img v-if="group.entityType === `VINEYARD` && group.county === 28"
                       :src="iconToDisplay(group.entityType,group.county)"
                       alt="NapaGreen Vineyard"
                       style="height: 75px; float: right; clear: right; color: lightgreen">
                  <img v-if="group.entityType === `WINE` && group.county !== 28"
                       :src="iconToDisplayClimate(group.entityType)"
                       alt="NapaGreen Winery"
                       style="height: 75px; float: right; clear: right; color: lightgreen">
                  <img v-if="group.entityType === `VINEYARD` && group.county !== 28"
                       :src="iconToDisplayClimate(group.entityType)"
                       alt="NapaGreen Vineyard"
                       style="height: 75px; float: right; clear: right; color: lightgreen">
                </b-col>
                <b-col cols="7">
                  <b-row>
                    <b-col cols="4" style="text-align: left">Name:</b-col>
                    <b-col cols="4" style="text-align: left">{{ group.name }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="4" style="text-align: left">Last Certification Date:</b-col>
                    <b-col cols="8">{{ getLastCertificationDate(group.certificationDates) }}</b-col>
                  </b-row>
                </b-col>

                <b-col cols="4">
                      <span :style="getColor(group.entityType, group.isCurrentGroup)">
                        <span :style="getIconStyle(group.entityType, group.isCurrentGroup)">
                          <i class="fas fa-check fa-5x" aria-hidden="true"></i>
                        </span>
                      </span>
                </b-col>

              </b-row>
            </b-card>
          </b-container>
        </b-col>
        <b-col cols="3"></b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import Bus from "../eventBus";

export default {
  name: "AccountRequestList",
  data() {
    return {
      groups: [],
      currentGroupKey: localStorage.getItem('groupId')
    }
  },
  mounted() {
    let self = this;
    this.$http.get("account/user/" + localStorage.getItem("user") + "/groups")
        .then(result => {
          this.groups = result.data;
          console.log(this.requests)
        })
        .catch(error => {
          console.log("Couldn't Retrieve Requests");
        })
  },
  methods: {
    iconToDisplay: function (entityType, county) {
      let ent = '';
      console.log(`Entity Type: ${entityType}`)
      if (entityType === "WINE") {
        if (county === "28" || county === 28) {
          ent = 'napa_green_winery';
        } else {
          ent = 'beyond-green-winery';
        }
      } else {
        if (county === "28" || county === 28) {
          ent = 'napa_green_vineyard';
        } else {
          ent = 'beyond-green-vineyard';
        }

      }

      let item = `@/assets/${ent}.jpg`;
      console.log("Icon To Display: ", item)
      return require("@/assets/" + ent + ".jpg");
      //  return item;
    },
    iconToDisplayClimate: function (entityType) {
      let ent = '';
      if (entityType === "WINE") {
        ent = 'beyond-green-winery';
      } else {
        ent = 'beyond-green-vineyard';
      }

      let item2 = `@/assets/${ent}.jpg`;
      console.log("Climate Icon To Display: ", item2)
      return require("@/assets/" + ent + ".jpg");
      //  return item;
    },
    getColor(entityType) {
      let colorStyle = entityType === `WINE` ? `color:#96212d;` : `color:rgba(44,108,55,1);`;
      return colorStyle + "padding-top: 50px; border: 5px solid #A9A9A9;";
    },
    getIconStyle(entityType, isVisible) {
      let visibility = isVisible ? "visible" : "hidden";
      let colorStyle = entityType === `WINE` ? `visibility:${visibility};` : `visibility:${visibility};`;
      return colorStyle;
    },
    getLastCertificationDate: function (certificationDates) {

      if (certificationDates !== null && certificationDates.length !== 0) {
        let datesLength = certificationDates.length;
        return certificationDates[datesLength]
      } else {
        return "Not Certified";
      }
    },
    setGroup: function (groupId, name, entityType) {
      console.log("Group Selector");
      localStorage.setItem("groupId", groupId);
      this.$store.commit('user/groupId', groupId);
      localStorage.setItem("entityType", entityType);
      this.$store.commit('user/entityType', entityType);
      let self = this;
      this.$http.get("survey/response/" + groupId,
          {
            headers: {
              'content-type': 'application/json'//,
            }
          })
          .then(result => {
            //TODO Rework this to get the surveyResponseId & the EntityType
            localStorage.setItem('surveyResponseId', result.data._id);
            this.$store.commit('user/surveyResponseId', result.data._id);
            localStorage.setItem('surveyKey', result.data.surveyKey);
            this.$store.commit('user/surveyKey', result.data.surveyKey);
            Bus.$emit('group-update', `${name}(${entityType})`);
            Bus.$emit('update-entityType', entityType);
            swal("THANK YOU", "Your Group Is Now: " + name, "success");
            self.currentGroupKey = groupId;

          }).catch(error => {
        console.log(error);
        swal("Error", "Unable To Switch Groups", "failed");
      });
      this.$http.get("groups/" + groupId,
          {
            headers: {
              'content-type': 'application/json'//,
            }
          })
          .then(result => {
            console.log(result.data.county);
            localStorage.setItem('county', result.data.county);
            this.$store.commit("user/currentCounty", result.data.county, {root: true})
          })
    }
  },
  computed: {
    groupsUpdated() {
      return this.groups.map(group => {
        group.isCurrentGroup = this.currentGroupKey === group._id;
        return group;
      })
    }
  }
}
</script>

<style scoped>

</style>
